<template lang="pug">
  // ALTERADO: Props 'lazy' e 'full-width' removidas. Sintaxe do ativador atualizada.
  v-menu(
    ref='menu'
    v-model='menu'
    transition='scale-transition'
    offset-y
    :close-on-content-click='false'
    :disabled='disabled'
    max-width='290px'
    min-width='290px'
  )
    // ALTERADO: Sintaxe do ativador atualizada para Vuetify 2
    template(v-slot:activator="{ on, attrs }")
      v-text-field(
        :class='innerStyle'
        v-model='dateFormatted'
        mask='##/##/####'
        :prefix='prefix'
        :label='label'
        append-icon='event'
        :hide-details='hideDetails'
        :disabled='disabled'
        @blur='date = parseDate(dateFormatted)'
        v-bind='attrs'
        v-on='on'
      )
    v-date-picker(
      v-model='date'
      no-title
      :disabled='disabled'
      @input='menu = false'
      locale='pt'
    )
</template>

<script>
import moment from 'moment'

export default {
  name: 'date',
  inheritAttrs: false,
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: 'Data'
    },
    prefix: {
      type: String
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    resultDate: {
      type: Boolean,
      default: false
    },
    innerStyle: {
      type: String
    }
  },
  watch: {
    value(val) {
      if ([null, '', undefined].indexOf(val) > -1) {
        this.date = moment().format('YYYY-MM-DD')
        this.dateFormatted = null
        return
      }
      this.dateFormatted = this.resultDate ? moment(val).format('DDMMYYYY') : val
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date)
    },
    dateFormatted(val) {
      if (val === null || val.length < 8) {
        this.$emit('input', null)
        return
      }
      if ((this.value && this.value.toString() === val.toString()) || val === '') return
      const dateMoment = moment(val, 'DDMMYYYY')
      this.date = dateMoment.format('YYYY-MM-DD')
      this.$emit('input', this.resultDate ? dateMoment.toDate() : val)
    }
  },
  data() {
    return {
      date: null,
      dateFormatted: null,
      menu: false
    }
  },
  mounted() {
    if ([null, '', undefined].indexOf(this.value) > -1) return
    const dateMoment = this.resultDate ? moment(this.value) : moment(this.value, 'DDMMYYYY')
    this.date = dateMoment.format('YYYY-MM-DD')
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}${month}${year}`
    },
    parseDate(date) {
      if (!date) return null
      const day = date.substr(0, 2)
      const month = date.substr(2, 2)
      const year = date.substr(4, 4)
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>
